/*
 * controllers/skiController.js
 * Ski Controller
 */

define('app/controllers/skiController',[
    'app/ControllerClass',
    'app/models/skiModel',
    'app/views/skiView'], function (ControllerClass, SkiModel, SkiView) {
    return window.app.controllers.skiController = $.extend({}, ControllerClass, {
        app:app,
        module:'ski',

        actions:{
            'show':['skiBookingSelected'],
            'liftTickets':['skiLiftTicketsSelected'],
            'purchase':['purchaseSkiItem','purchaseSkiItem'],
            'purchasePass':['purchaseSkiItem','purchaseSkiPass']
        },
        init:function () {
            console.log('initializing ski controller');
            app.data.messages = app.data.messages || [];
        },

        skiBookingSelected:function () {
            var self = this;
            $.when(
                app.models.skiModel.getData('skiLocations', {}),
                (app.customization.hideOtherPropertyIfItemsInCart && app.models.systemModel.validatePMSBeforeSpa())
            )
                .done(function (r_sl, r_pbs) {

                    if (!!r_sl.SkiLocation) {

                        var skiLocations = r_sl.SkiLocation;
                        var membershipIds = app.data.membershipDetails && app.data.membershipDetails.membershipItemIds || [];
                        var vipLevels = app.data.membershipDetails && app.data.membershipDetails.VIPLevels || [];
                        // Dynamic restriction tryingToBook_module
                        app.commonViewHelper.eval_ttb({module:"skiBooking", vipLevel: vipLevels, membershipId:membershipIds});
                        // Dynamic restriction code for enable SkiLocations
                        if(app.customization.dynamicRestrictions && app.commonViewHelper.activeEffects.enableSkiLocations){
                            var enableSkiLocationsResult = app.commonViewHelper.groupEffects(app.commonViewHelper.activeEffects.enableSkiLocations);
                            if(enableSkiLocationsResult.isActive && enableSkiLocationsResult.value && enableSkiLocationsResult.value.length){
                                if(typeof enableSkiLocationsResult.value == 'object' && enableSkiLocationsResult.value.length && typeof enableSkiLocationsResult.value[0] == 'function'){
                                    _.each(enableSkiLocationsResult.value, function(func){
                                        skiLocations = func(skiLocations);                                    
                                    })
                                } else {
                                    skiLocations = _.filter(skiLocations, function(skiLocation){
                                        return _.contains(enableSkiLocationsResult.value, skiLocation.LocationId);
                                    });
                                }
                            }                        
                        }
                        if (skiLocations.length == 0) {
                            app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                                title: app.localization.ski.err.noLocationAccess,
                                message: '' // r_pr.Result ? "(" + r_pr.Result.Text + ")" : ""
                            });
                            app.dispatcher.replace('','',[]);
                            return;
                        }
                        // Dynamic restriction code for enable SkiLocations
                        if (app.customization.hideOtherPropertyIfItemsInCart && (app.data.propertyIdsInCart.length > 0)) {
                            skiLocations = _.filter(skiLocations,function(x){
                                return _.any(app.data.propertyIdsInCart, function(y){ return y==x.PropertyId })
                            })
                            if (skiLocations.length==0) {
                                app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                                    title: app.localization.ski.err.noLocationsAtProperty,
                                    message: '' // r_pr.Result ? "(" + r_pr.Result.Text + ")" : ""
                                });
                                app.dispatcher.redirect('summary','',[]);
                                return;
                            }
                        }

                        if (skiLocations.length > 1) {
                            app.views.skiView.event.fire('requestSkiLocationSelection', [skiLocations]);
                        } else {
                            var skiLocationId = $.firstOrOnly(skiLocations).LocationId;
                            //app.models.skiModel.setSelected('skiLocations', {}, skiLocationId);
                            self.skiLiftTicketsSelected('Location'+skiLocationId);
                            // app.dispatcher.replace('ski','location',[skiLocationId]);
                        }
                    } else {
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                            title:app.localization.ski.err.noLocation/*,
                            message:"(" + r_ss.Result.Text + ")"*/
                        });
                        app.dispatcher.redirect('');
                    }
                })
                .fail(function (r_sl) {
                    app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                        title:app.localization.ski.err.noLocation
                    });
                    app.dispatcher.redirect('');
                });
        },

        skiLiftTicketsSelected:function (showitem, date, selectedRecipient,promoCode) {
            if (showitem && showitem.substr(0, 8) == "Location") {
                var showitemParts = showitem.split('|');
                app.models.skiModel.setSelected('skiLocations', {}, showitemParts[0].substr(8));
                showitem = showitemParts[1];
            }
            if(promoCode) app.datal('skiPromoCode',promoCode)
            var self = this,
                location = undefined,
                loadProfileData = false,
                params = {};

            if (app.data.userLoggedIn) {
                loadProfileData = true;
                params = {
                        CustomerId: app.data.CustomerId,
                        CustomerGUID: app.data.CustomerGUID
                    },
                    dfd = $.Deferred();
                app.models.userModel.getData('fetchGroupMembers', params ).always(function(x){
                    dfd.resolve(x);
                })
            }


            app.models.skiModel.getData('skiLocations', {}).done(function(r_sl){
                location = app.models.skiModel.getSelectedItem('skiLocations', {});
                if (!location) {
                    app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                        title:app.localization.ski.err.noLocation,
                        message: '' // r_pr.Result ? "(" + r_pr.Result.Text + ")" : ""
                    });
                    app.dispatcher.redirect('ski','',[]);
                    return;
                }
                params.CustomerId= selectedRecipient || app.data.CustomerId || app.data.DefaultCustomerId;
                
                // Inhibits Ski packages on locations
                function removeSkiPackageifCustomization(skiItems, location) {
                    if(app.customization.skiBooking.inhibitSkiPackagesOnLocations.indexOf(location) !== -1) {
                        delete skiItems.Packages;
                    };
                };
                if (!/\d{4}-\d{2}-\d{2}/.test(date)) {
                    date=Date.today().add(app.customization.skiBooking.allowBookingToday ? 0 : 1).days().toString('yyyy-MM-dd');
                }
                if (app.customization.skiBooking.queryAdvanceDays) {
                    var today=Date.today().add(app.customization.skiBooking.allowBookingToday ? 0 : 1).days()
                    date = Date.parse(app.customization.skiBooking.queryStartDate);
                    date = (date.valueOf() < today.valueOf() ? today.clone() : date);
                    params.StartDate=date.toString('yyyy-MM-dd').substr(0,10)+'000000';
                    var dateEnd = date.clone().add(app.customization.skiBooking.queryAdvanceDays).days();
                    if (dateEnd.valueOf()<today.valueOf()) {
                        dateEnd = today.clone()
                    }
                    params.EndDate=dateEnd.toString('yyyy-MM-dd')+'000000';
                    date = date.toString('yyyy-MM-dd');
                } else if(date) {
                    params.StartDate=date.substr(0,10)+'000000';
                }
                var profileParams = {
                        CustomerId: app.data.CustomerId,
                        CustomerGUID: app.data.CustomerGUID
                    }

                $.when(
                    $.promiseFilter( app.models.skiModel.getData('skiItems', params),
                        function(succeeded,args){
                            if (succeeded) return true;
                            if (args[0] && args[0].Result && args[0].Result.ErrorId) {
                                return (args[0].Result.ErrorId == '715')
                                     ||(args[0].Result.ErrorId == '999')
                            } else {
                                return false;
                            }
                        }),
/*                    $.promiseFilter( app.models.skiModel.getData('skiPasses', params),
                        function(succeeded,args){
                            if (succeeded) return true;
                            if (args[0] && args[0].Result && args[0].Result.ErrorId) {
                                return args[0].Result.ErrorId == '999'
                            } else {
                                return false;
                            }
                        }),*/
                    (app.customization.hideOtherPropertyIfItemsInCart && app.models.systemModel.validatePMSBeforeSpa()),
                    (loadProfileData && app.models.userModel.getData('fetchCustomerProfile', profileParams )),
                    (loadProfileData && dfd.promise())
                )
                    .done(function (r_si, /*r_si,*/ r_pbs, r_fcp, r_fgm) {
                        var skiLocations = r_sl.SkiLocation;
                        if (app.customization.hideOtherPropertyIfItemsInCart && (app.data.propertyIdsInCart.length > 0)) {
                            skiLocations = _.filter(skiLocations,function(x){
                                return _.any(app.data.propertyIdsInCart, function(y){ return y==x.PropertyId })
                            })
                            if (skiLocations.length==0) {
                                app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                                    title:app.localization.ski.err.noLocationsAtProperty,
                                    message: '' // r_pr.Result ? "(" + r_pr.Result.Text + ")" : ""
                                });
                                app.dispatcher.redirect('summary','',[]);
                                return;
                            } else if (!_.any(skiLocations,function(x){return x.LocationId == location.LocationId})) {
                                app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                                    title:app.localization.ski.err.mismatchedProperty,
                                    message: '' // r_pr.Result ? "(" + r_pr.Result.Text + ")" : ""
                                });
                                app.dispatcher.redirect('summary','',[]);
                                return;
                            }
                        }
                        showitem = showitem || // $.firstOrOnly($.first(r_si).value.value).SkiItemId;
                                   ( $.isArray(r_si) && $.isArray($.first(r_si).value) &&
                                        r_si.length==1 && $.first(r_si).value.length==1
                                        ? $.firstOrOnly($.first(r_si).value.value).SkiItemId : "" );
                        var user = {},
                            group = [];
                        if (loadProfileData) {
                            user = r_fcp && r_fcp.Customer
                                    ? ($.isArray(r_fcp.Customer) ? r_fcp.Customer[0] : r_fcp.Customer)
                                    : {};
                            group = r_fgm && r_fgm.GroupMember
                                    ? ($.isArray(r_fgm.GroupMember) ? r_fgm.GroupMember : [r_fgm.GroupMember] )
                                    : []
                        }
                        if (
                            (r_si.LiftTickets && r_si.LiftTickets.LiftTicket)
                            ||(r_si.PromoLiftTickets && r_si.PromoLiftTickets.LiftTicket)
                            ||(r_si.Passes && r_si.Passes.Pass)
                            ||(r_si.PromoPasses && r_si.PromoPasses.Pass)
                        ) {

                            /*if (r_si.LiftTickets && r_si.LiftTickets.LiftTicket) {
                                r_si.LiftTickets.LiftTicket = $.wrapArray(r_si.LiftTickets.LiftTicket);
                            }
                            if (r_si.PromoLiftTickets && r_si.PromoLiftTickets.LiftTicket) {
                                r_si.PromoLiftTickets.LiftTicket = $.wrapArray(r_si.PromoLiftTickets.LiftTicket);
                            }
                            if (r_si.Passes && r_si.Passes.Pass) {
                                r_si.Passes.Pass = $.wrapArray(r_si.Passes.Pass);
                            }
                            if (r_si.PromoPasses && r_si.PromoPasses.Pass) {
                                r_si.PromoPasses.Pass = $.wrapArray(r_si.PromoPasses.Pass);
                            }*/
                            removeSkiPackageifCustomization(r_si, location.LocationId);
                            app.views.skiView.event.fire('requestSkiLiftTicketSelection', [ r_si, showitem, location, date, selectedRecipient, user, group ]);
                        } else {
                            var message = app.localization.ski.err.noAvailableItems;
                            if (r_si.Result && r_si.Result.ErrorId == '715') {
                                var closeDates = /Location closed ([\d-]+) and will reopen ([\d-]+)/.exec(r_si.Result.Text);
                                if (closeDates) {
                                    var closeBeginDate = Date.parseExact(closeDates[1], "yyyy-MM-ddHHmmss"),
                                        closeEndDate = Date.parseExact(closeDates[2], "yyyy-MM-ddHHmmss");
                                    message = _.template(app.localization.ski.err.locationClosed)({
                                        closeBeginDate: closeBeginDate.toString(app.localization.CultureInfo.formatPatterns.longDate),
                                        closeEndDate: closeEndDate.toString(app.localization.CultureInfo.formatPatterns.longDate)
                                    })
                                } else {
                                    message = app.localization.ski.err.locationClosedNoDate;
                                }
                            }

                            app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                                title:message /*,
                                message:"(" + r_si.Result.Text + ")"*/
                            });
                            removeSkiPackageifCustomization(r_si, location.LocationId);
                            app.views.skiView.event.fire('requestSkiLiftTicketSelection', [ r_si, showitem, location, date, selectedRecipient, user, group ]);
                        }

                    })
                    .fail(function (r_si) {
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                            title:app.localization.ski.err.noService /*,
                            message:"(" + r_si.Result.Text + ")"*/
                        });
                        app.dispatcher.redirect('ski');
                    });
            })
        },


        purchaseSkiItem: function (itemtype, itemId, date, customerId, wptNumber, guestNote,packageItemWTPNo, packageItemCustomerIds, packageItemId,packageItemGuestNotes) {

            if (!/\d{4}-\d{2}-\d{2}/.test(date)) {
                app.dispatcher.replace('ski', 'liftTickets', [itemId])
                return;
            }
            date = date.substr(0,10);
            var params = {
                SkiItemId: itemId,
                StartDate: date + "000000",
                Qty: 1
            };
            if (wptNumber) {
                params.WTPNo  = wptNumber
            }
            if ( customerId || app.data.CustomerId ) {
                params.CustomerId =  customerId || app.data.CustomerId;
            }
            if(guestNote) params.GuestRequest = guestNote
            if (packageItemId) {
                params.SkiItemId = '';
                var packageItemIds = packageItemId.split('|')
                if (packageItemWTPNo) {
                    var packageCustomerIds = packageItemCustomerIds.split('|')
                    _.each(packageCustomerIds, function (item,i){
                        params['SkiPackage:PackageId='+itemId+'.PackageItem['+i+']:Id='+packageItemIds[i]+'.WTPNo'] = item
                    })
                }
                if (packageItemCustomerIds) {
                    var packageCustomerIds = packageItemCustomerIds.split('|')
                    _.each(packageCustomerIds, function (item,i) {
                        params['SkiPackage:PackageId='+itemId+'.PackageItem['+i+']:Id='+packageItemIds[i]+'.CustomerId'] = item
                    })
                }
                if (packageItemGuestNotes) {
                    var packageGuestNotes = packageItemGuestNotes.split('|')
                    _.each(packageGuestNotes, function (item,i) {
                        params['SkiPackage:PackageId='+itemId+'.PackageItem['+i+']:Id='+packageItemIds[i]+'.GuestRequest'] = item
                    })
                }
            }

            app.models.skiModel.getData(itemtype, params)
                .done(function (r_pslt) {
                    console.log('r_pslt', r_pslt)
                    app.data.messages.push({ type:'alert', 'class':'alert-success', actions:[],
                        title:app.localization.ski.successfullBookingMessage,
                        message:app.localization.ski.customerCustomTextFooter
                    });
                    if( r_pslt.rawData.SkiFolioItems){ //summary page doesnt show indivdual package items, so for now storing it for non package items
                    var skiFolioItems =    $.isArray( r_pslt.rawData.SkiFolioItems.SkiFolioItem) ?  r_pslt.rawData.SkiFolioItems.SkiFolioItem : [r_pslt.rawData.SkiFolioItems.SkiFolioItem]
                     _.each(skiFolioItems,function(folio){
                        app.data.skiGuestNotes =  app.data.skiGuestNotes || {}
                       !app.data.skiGuestNotes.hasOwnProperty(folio.SkiFolioItemId) ? app.data.skiGuestNotes[folio.SkiFolioItemId]  = guestNote :''
                        app.datal('skiGuestNotes', app.data.skiGuestNotes)
                    })
                    }
                    //app.models.systemModel.getData('folioBalance', {}).always(function () {
                        app.commonViewHelper.updatePlaceHolderDate(date);
                        
                        app.dispatcher.replace('summary', 'show', []);
                    //});
                })
                .fail(function (r_pslt) {
                    var message = app.localization.ski.err.createBookingFailed;
                    if (r_pslt.Result && r_pslt.Result.ErrorId == '711') {
                        message  = app.localization.ski.err.createBookingFailedLimitExceeded;
                    }
                    app.data.messages.push({ type:'alert', 'class':'alert-error', actions:[],
                        title:message,
                        message:'' // "(" + r_pslt.Result.Text + ")"
                    });
                    app.dispatcher.replace('ski', 'liftTickets', [itemId, date, customerId])
                })
        }

    })
});

